const $ = jQuery.noConflict();

export const searchableDropdown = (() => {
   // $('.search-taxonomy').select2({
   //     formatNoMatches: function () { return "Nothing found"; }
  //  });

   /* $('.taxonomy-dropdown').each((i, e) => {
        const taxonomyDropdown = $(e);
        taxonomyDropdown.dropdown({
            input: `<input type="text" maxLength="20" placeholder="Wpisz ${taxonomyDropdown.data('taxonomy').toLowerCase()}">`,
            searchNoData: '<li style="color:#ddd">Brak wyników</li>',
            searchable: !taxonomyDropdown.hasClass('no-searchable'),
            choice: (e) => {
                const that = $(e.delegateTarget);
                console.log(that);
                if (that.find('select option:selected').length) {
                //    that.find('label').hide();
                } else {
                 //   that.find('label').show();
                }
                let event = new CustomEvent('executeSearchReload', {detail: that.find('select').attr('id')});
                document.dispatchEvent(event)
            },
            init: () => {
                const props = $('.additional-props');
                props.find('li').each((i, e) => {
                    const element = props.siblings('.dropdown-main').find(`li[data-value='${$(e).data('term')}']`);
                    if (props.siblings('.dropdown-main').length) {
                        element.html(`<span style="background: ${$(e).data('color')}"></span>${element.text()}`);
                    }
                });
            },
        });
    }); */
});
